const pending = new Set<Promise<unknown>>();
let lastActivityAt = 0;
/** Include queued work before playback/dispatch actually starts. */
export function trackVoiceWork<T>(work: Promise<T>): Promise<T> {
  pending.add(work);
  lastActivityAt = Date.now();
  void work.then(
    () => settled(work),
    () => settled(work),
  );
  return work;
}
function settled(work: Promise<unknown>): void {
  pending.delete(work);
  lastActivityAt = Date.now();
}
export function hasPendingVoiceWork(): boolean {
  return pending.size > 0;
}
export function voiceWorkLastActivityAt(): number {
  return lastActivityAt;
}
